__turbopack_context__.v({
  "ckeditorBlogs": "ckeditorEUI-module__pIddja__ckeditorBlogs",
  "rotate-border": "ckeditorEUI-module__pIddja__rotate-border",
});
